import React, {useEffect, useState} from 'react';
import {JsonApiClient} from "@drupal-api-client/json-api-client";
import Config from "../../utils/Config";
import {Jsona} from "jsona";

import Moment from 'react-moment';
import Box from "@mui/material/Box";
import {IAttendee, IAddress, IEvent, IPlace, ISchedule, IDateRange, IRichText} from "./Buxliest";
import AttendeesEventListItem from "./AttendeesEventListItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import {Select, SelectChangeEvent} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import SchedulCheckinAttendee from "./SchedulCheckinAttendee";


const client = new JsonApiClient(Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl'), {
  serializer: new Jsona()
});

export interface IScheduleCheckinProps {
  scheduleId: string;
}

const ScheduleCheckin = (props: IScheduleCheckinProps) => {
  const [schedule, setSchedule] = useState<ISchedule>(null);
  const [event, setEvent] = useState<IEvent>(null);

  const [attendees, setAttendees] = useState<IAttendee[]>([]);

  const [submitting, setSubmitting] = useState<boolean>(false);

  const loadSchedule = async () => {
    let schedule = await client.getResource("bux_schedule/bux_schedule", props.scheduleId, {
      queryString: "include=place,events",
    }) as any;
    console.log('schedule:', schedule);
    setSchedule(schedule);
    setSubmitting(false);
  };

  const loadEvent = async (id) => {
    let event = await client.getResource("bux_event/bux_event", id, {
      queryString: "include=attendees",
    }) as any;
    console.log('event:', event);
    setEvent(event);
    setSubmitting(false);
  };

  const loadAttendees = async (value) => {
    let attendees = await client.getCollection("bux_attendee/bux_attendee", {
      queryString: "include=event&filter[event.id]="+value+"&sort=field_address.family_name",
    }) as any;
    console.log('Attendees:', attendees);
    setAttendees(attendees);
    setSubmitting(false);
  };

  useEffect(() => {
    loadSchedule();
  }, []);

  const handleAttendeeCheckinChange = (attendee: IAttendee, checkin: boolean) => {
    loadAttendees(attendee.event.id);
  };

  const handleEventChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    loadAttendees(value);
    const lesung = (schedule.events.filter((item) => item.id == value))[0];
    setEvent(lesung);
  };

  return (
    <div className="max-w-7xl max-lg:max-w-4xl mx-auto py-8 px-4 max-w-[800px]">
      <div className="text-3xl pb-4">{schedule?.place.title}</div>
      <Box className="mb-8">
        <FormControl variant={"outlined"} sx={{width: "100%"}}>
          <InputLabel id="event-label">Lesung</InputLabel>
          <Select
            labelId="event-label"
            id="event-select"
            defaultValue={event?.id}
            value={event?.id}
            label="event"
            onChange={handleEventChange}
          >
            {schedule?.events.map((event, index) =>
              <MenuItem key={index} value={event.id}>{event.title}</MenuItem>
            )}

          </Select>
        </FormControl>
      </Box>
      {event && (
        <>
          <div className="text-2xl pb-4">Teilnehmer</div>
          {(!attendees || attendees.length == 0) && (
            <p>Für diese Lesung gibt es noch keine Teilnehmer</p>
            )}
          <div
            className="grid items-start grid-cols-1 md:grid-cols-1 max-w-[800px] divide-y divide-gray-300 ">

            {attendees.filter((attendee) => !attendee.waitlist).map((item, i) =>
              <Box className="pt-4 pb-4">
                <SchedulCheckinAttendee attendee={item}
                                        onChange={handleAttendeeCheckinChange}></SchedulCheckinAttendee>
              </Box>
            )}
          </div>

          {attendees?.filter((attendee) => attendee.waitlist).length > 0 && (
            <>
              <div className="text-2xl my-8">Auf der Warteliste</div>
              <div
                className="grid items-start grid-cols-1 md:grid-cols-1 max-w-[800px]">
                {attendees?.filter((attendee) => attendee.waitlist).map((item, i) =>
                  <Box className="pb-4 mb-4  border-b border-gray-300">
                    <SchedulCheckinAttendee attendee={item}
                                            onChange={handleAttendeeCheckinChange}></SchedulCheckinAttendee>
                  </Box>
                )}
              </div>
            </>
          )}
        </>
      )}

      {!event && (
        <p>Bitte wählen sie eine Lesung aus.</p>
        )}

    </div>
  );

};

export default ScheduleCheckin;
